import axios from 'axios';
import {backendHost} from '../../config';

export const postTokenUser = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/signuser`, params);
};